export default __webpack_public_path__ + "static/media/sonprayag.82447efc.jpeg";